import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {AuthService} from '../services/auth.service';
import {UrlConstants} from '../../shared/utils/url-constants';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router
  ) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {

    if (!this.authService.isLoggedIn()) {
      if (this.authService.isProductionRequestUser()) {
        this.router.navigate([UrlConstants.DASHBOARD]);
      } else {
        this.router.navigate([UrlConstants.LOGIN], {queryParams: {returnUrl: state.url}});
      }

      return false;
    } else {
      return true;
    }
  }
}

